import React from "react"
import PropTypes from "prop-types"
// Components
import Grid from "../Grid/Grid"
// Styles
import { Container, Details, Image, ImageContainer, ProductDetail, ProductInfo } from "./Favorites.styles"


const Favorites = ({ products }) => {
    return (
        <Container>
            <Grid>
                {products.map((product) => (
                    <ProductDetail key={product.variationId}>
                        <ImageContainer>
                            <Image src={product.imageUrl} />
                        </ImageContainer>
                        <Details>
                            <ProductInfo><b>Modèle : </b>{product.model}</ProductInfo>
                            <ProductInfo><b>Code : </b>{product.code}</ProductInfo>
                            <ProductInfo><b>Couleur : </b>{product.detailedColor}</ProductInfo>
                            <ProductInfo><b>Taille : </b> {product.size}</ProductInfo>
                        </Details>
                    </ProductDetail>
                ))}
            </Grid>
        </Container>
    )
}

Favorites.propTypes = {
    products: PropTypes.arrayOf(PropTypes.object)
}

export default Favorites
